export default () => {
    const button = document.querySelector(".js-toggle-nav");
    const mobileNav = document.querySelector(".js-mobile-nav");
    const mobileChild = document.querySelectorAll(".js-mobile-child");

    const closeMenu = () => {
        document.body.classList.remove("menu-open");
        document.documentElement.classList.remove("menu-open");
        mobileNav.classList.remove("c-mobile-nav--active");
        button.setAttribute("aria-expanded", false);
        button.setAttribute("aria-label", "Menu openen");
    };

    if (button) {
        button.addEventListener("click", (e) => {
            const isOpen = document.body.classList.toggle("menu-open");
            document.documentElement.classList.toggle("menu-open");
            mobileNav.classList.toggle("c-mobile-nav--active");
            button.setAttribute("aria-expanded", isOpen);
            button.setAttribute(
                "aria-label",
                isOpen ? "Menu sluiten" : "Menu openen",
            );
        });

        document.addEventListener("keydown", (e) => {
            if (
                e.key === "Escape" &&
                document.body.classList.contains("menu-open")
            ) {
                closeMenu();
            }
        });
    }

    if (mobileChild.length) {
        [...mobileChild].forEach((child) => {
            const target = child.nextElementSibling;
            child.addEventListener("click", (e) => {
                const isExpanded = target.classList.toggle(
                    "c-mobile-nav__child-container--active",
                );
                child.classList.toggle("c-mobile-nav__link--active");
                child.setAttribute("aria-expanded", isExpanded);
            });
        });
    }
};

// WEBPACK FOOTER //
// ./src/js/modules/MobileHeader.js
